export default "__VITE_ASSET__4qV7JMrB__"